
<template>
  <div
    v-if="isLogin"
    @click="clickEmail"
    class="notice"
    :class="{
      'red-dot': showRedDot,
    }"
  >
    <img class="img" :src="require('@/assets/home/icon-email.png')" alt="" />
  </div>
</template>

<script>
import { findUserPagePath } from "@/lobby_common/utils/comVariables";
export default {
  name: "emailIcon",
  data() {
    return {
      redDot: false,
      timer: null,
    };
  },
  computed: {
    hasNewNotice() {
      return this.$store.getters.getNewNotice;
    },
    getIsMobile() {
      return this.$store.getters.getIsMobile;
    },
    isLogin() {
      return this.$store.getters.login;
    },
    showRedDot() {
      return this.isLogin && (this.redDot || this.hasNewNotice);
    },
  },
  methods: {
    clickEmail() {
      this.$eventPost("Click_mailbox", {
        SubMail: "hall",
      });
      // this.$store.commit("setNewNotice", false);
      this.$router.push(findUserPagePath("/user/notice"));
      // this.$router.push({
      //   name: "hNoticeCenter",
      // });
      this.$Bus.$emit("emailClick");
    },
  },
};
</script>

<style scoped lang="scss">
.notice {
  position: relative;
  width: 34px;
  height: auto;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  .img {
    width: 100%;
    height: auto;
  }
  &.red-dot {
    // animation: shake 0.8s ease-in-out;
    animation: tada 1s ease-in-out infinite 1s;
    &::after {
      content: "1+";
      position: absolute;
      width: 14px;
      height: 14px;
      font-size: 10px;
      line-height: 12px;
      text-align: center;
      right: -2px;
      top: -1px;
      border-radius: 50%;
      color: #fff;
      background: #f70c07;
    }
  }
}
</style>
